module.exports = __webpack_public_path__ + "static/img/logo.cdfc87c8.png";